import React, { createContext, useContext } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

const SettingsContext = createContext(null);

const EMPTY = {
  general: {}, banners: [], announcement: {}, whatsapp: {},
  sale: {}, social: {}, seo: {}, popup: {}, loading: false,
};

export function SettingsProvider({ site = 'alsami', skip = false, value, children }) {
  const fromHook = useSiteSettings(site, skip || !!value);
  return (
    <SettingsContext.Provider value={value || fromHook}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || EMPTY;
}
